import { TokenType } from 'state/types';

interface TokenCredentials {
  tenantToken?: string | null;
  cognitoToken?: string;
  entraToken?: string;
}

/**
 * Single source of truth for the active GraphQL token type. Derives the type
 * purely from which credential currently exists, in a fixed priority so the
 * result never depends on async resolution order.
 */
export const deriveTokenType = ({ tenantToken, cognitoToken, entraToken }: TokenCredentials): TokenType => {
  if (tenantToken) return 'TENANT';
  if (cognitoToken) return 'COGNITO';
  if (entraToken) return 'ENTRA';
  return 'NONE';
};
